import { useEffect, useState } from 'react';

import { scroller } from 'react-scroll';

import {
  LANDING_THEMES,
  NOMAD_THEME_HEADER_HEIGHT,
  NOMAD_THEME_MOBILE_HEADER_HEIGHT,
  JBD_THEME_MOBILE_HEADER_HEIGHT,
  JBD_THEME_HEADER_HEIGHT,
} from 'utils/itineraries/functions';

import useMediaBreakpoints from './useMediaBreakpoints';

export function useLandingNavigation(props) {
  const { isItinerariesItem = false, isPortalItinerary = false, isPortal = false, elemId, type, landingTheme } = props;
  const [elem, setElem] = useState(null);
  const elemHeight = elem ? elem?.offsetHeight : 0;
  const { isTabletOrMobile } = useMediaBreakpoints();

  const getClickX = () => {
    if (landingTheme === LANDING_THEMES.nomad) {
      return isTabletOrMobile ? NOMAD_THEME_MOBILE_HEADER_HEIGHT : NOMAD_THEME_HEADER_HEIGHT;
    }

    if (landingTheme === LANDING_THEMES.jbd) {
      return isTabletOrMobile ? JBD_THEME_MOBILE_HEADER_HEIGHT : JBD_THEME_HEADER_HEIGHT;
    }

    if (isItinerariesItem || isPortalItinerary) return 0;
    if (isPortal && type === 'arrowLink') return 46;
    if (type === 'arrowLink') return 46;
    if (type === 'navNotch') return 46;
    if (type === 'builderNav') return 46;
    return 0;
  };

  const getBaseX = () => {
    if (landingTheme === LANDING_THEMES.nomad) {
      const baseHeight = isTabletOrMobile ? NOMAD_THEME_MOBILE_HEADER_HEIGHT : NOMAD_THEME_HEADER_HEIGHT;
      return baseHeight + 1;
    }

    if (landingTheme === LANDING_THEMES.jbd) {
      const baseHeight = isTabletOrMobile ? JBD_THEME_MOBILE_HEADER_HEIGHT : JBD_THEME_HEADER_HEIGHT;
      return baseHeight + 1;
    }

    if (type === 'navNotch') return 60;
    return 110;
  };

  const clickOffset = () => {
    const x = getClickX();
    return -(elemHeight + x);
  };

  const getBaseOffset = () => {
    const x = getBaseX();
    return -(elemHeight + x);
  };

  const handleLinkClick = (link, containerId) => {
    setTimeout(() => {
      scroller.scrollTo(link, { containerId, smooth: true, duration: 200, offset: clickOffset() });
    }, [100]);
  };

  useEffect(() => {
    if (isItinerariesItem || isPortalItinerary) return;
    const currentElem = document.getElementById(elemId);
    setElem(currentElem);
  }, [isPortalItinerary, isItinerariesItem, elemHeight, elemId]);

  return { clickOffset, getBaseOffset, handleLinkClick };
}
